import { type ApplicationSteps, type PartialRecord } from 'share/types'
import { pathnames } from 'utils/constants'

export const getMainFlowPaths = (key: ApplicationSteps): string | undefined => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    // Prescoring steps
    CHECK_DECISION_IIN: pathnames['prescoring-loader'],
    COLVIR_CHECK_IF_CORP_CARD_ALREADY_CREATED: pathnames['prescoring-loader'],
    PRE_SCORE: pathnames['prescoring-loader'],
    FETCH_PERSONAL_INFO: pathnames['prescoring-loader'],
    CREATE_APPLICATION_IN_TELEMARKETING: pathnames['prescoring-loader'],
    GENERATE_DOCUMENTS_SIGNED_BY_OTP: pathnames['prescoring-loader'],
    OPERATOR_BMG: pathnames['prescoring-loader'],

    BIOMETRY_AITU: pathnames['biometry'],
    BIOMETRY_FORENSICS: pathnames['biometry'],

    // Scoring steps
    FETCH_JUR_INFO: pathnames['scoring-loader'],
    PROPERTY_PLEDGES: pathnames['scoring-loader'],
    UPDATE_LOAN_DATA_IN_TELEMARKETING: pathnames['scoring-loader'],
    UPLOAD_UL_DATA_IN_TELEMARKETING: pathnames['scoring-loader'],
    SCORING: pathnames['scoring-loader'],
    FETCH_PKB_REPORT: pathnames['scoring-loader'],

    DECISION: pathnames.decision
  }
  return paths[key]
}
